import React, { useState } from "react";

import { Button } from "aible";

import { useSelector, useDispatch } from "types/store";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import * as loginReducer from "containers/Login/reducer";

import styles from "./style.module.css";

const SenseCorpusErrorCard = (props) => {
  const { currentCorpus } = props;

  const corpusErrorMessage = currentCorpus?.metadata?.message;
  const corpusId = currentCorpus?.id;

  function displayErrorMessages() {
    // MB: This code does not seem to be used anymore.
    if (Array.isArray(corpusErrorMessage)) {
      return corpusErrorMessage?.map((e) => {
        return <ErrorMessage error={e} key={e?.name} corpusId={corpusId} />;
      });
    }

    if (typeof corpusErrorMessage === "string") {
      const message = corpusErrorMessage;
      return [<ErrorMessage error={{ message }} key={corpusId + "-error-message"} corpusId={corpusId} />];
    }

    return undefined;
  }

  return (
    <React.Fragment>
      {corpusErrorMessage && (
        <div className={styles.openOverview} style={{ marginTop: "10px" }}>
          {displayErrorMessages()}
        </div>
      )}
    </React.Fragment>
  );
};

const ErrorMessage = (props) => {
  const { error, corpusId } = props;

  if (error?.name === undefined) {
    error.name = "Documents";
  }

  const dispatch = useDispatch();

  const storeItem = (key, value) => dispatch(loginReducer.storeItem(key, value));
  const getItem = (key) => dispatch((dispatch, getState) => loginReducer.getItem(getState(), key));
  const removeItem = (key) => dispatch(loginReducer.removeItem(key));

  const WARNING_KEY = "corpus_error_" + corpusId;
  let savedHidden = false;

  if (getItem(WARNING_KEY) !== undefined) {
    savedHidden = JSON.parse(getItem(WARNING_KEY))?.[error?.name] === true;
  }

  const [hideWarning, updateHideWarning] = useState(savedHidden);

  let warnings = {
    [error?.name]: true
  };

  return (
    <React.Fragment>
      {!hideWarning && (
        <div className={styles.corpusErrorMessageWrapper}>
          <div className={styles.corpusErrorTitleWrapper}>
            <span>
              <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#F8CD7E" }} />
            </span>
            <div className={styles.corpusErrorTitle}>{`${error?.name} Failed to Upload.`}</div>
          </div>
          <div>
            {/* <div className={styles.corpusErrorMessage}>{`${error?.name} failed to upload.`}</div> */}
            <div className={styles.corpusErrorMessage}>
              {
                "This might be due to formatting issues. Please review the recommendations below and try uploading again:"
              }
            </div>

            <div className={styles.corpusErrorListItem}>
              {"1: Documents and URLs should not be encrypted or password-protected."}
            </div>
            <div className={styles.corpusErrorListItem}>
              {
                "2: URLs should link to static HTML pages containing text. If uncertain, consider saving the page as a PDF."
              }
            </div>
            <div className={styles.corpusErrorListItem}>
              {
                "3: Ensure that documents and URLs contain readable text. Text within images or scanned PDFs won't be processed correctly."
              }
            </div>
            <div className={styles.corpusErrorListItem}>
              {
                "4: If your PDF contains scanned images, consider converting them to text using Optical Character Recognition (OCR) tools, which are available in many PDF applications."
              }
            </div>
          </div>

          <Button
            type="secondary"
            style={{
              marginTop: "24px"
            }}
            onClick={() => {
              if (getItem(WARNING_KEY) !== undefined) {
                warnings = {
                  ...JSON.parse(getItem(WARNING_KEY)),
                  [error?.name]: true
                };
              }
              updateHideWarning(true);
              storeItem(WARNING_KEY, JSON.stringify(warnings));
            }}
          >
            {"Hide Message"}
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};

export default SenseCorpusErrorCard;
